import { ref, unref, watch } from 'vue'

export function useVehicleParameters(vehicle) {
    const commands = ref([])
    const lock_command = ref(null)
    const new_lock_panel = ref({
        visible: false,
        lock_active: false,
        panel_data: null
    })

    // REFACTOR-022 (Sprint 12): watch mirato su dout_1/dout_2 (enable/value/lockStatus)
    // invece di deep:true sull'intero truck. Signature-string → il callback rifà il
    // dirty-check solo al cambio reale dei comandi. Con mergeTrucksDelta immutabile il
    // truck viene ricreato ad ogni delta (nuova reference): la signature evita di
    // rieseguire la logica quando i valori dei comandi non sono cambiati.
    // Vedi INVESTIGATION-001 F3.
    watch(
        () => {
            const v = unref(vehicle)
            const d1 = v?.lastpoint?.tracker?.config?.dout_1
            const d2 = v?.lastpoint?.tracker?.config?.dout_2
            return `${d1?.enable}|${d1?.value}|${d1?.lockStatus}|${d2?.enable}|${d2?.value}|${d2?.lockStatus}`
        },
        () => {
            // Reset the panel state at the start of each watch
            new_lock_panel.value = {
                visible: false,
                lock_active: false,
                panel_data: null
            }

            let command_source = null
            let vehicle_data = unref(vehicle)

            // Check which command source is active (dout_1 or dout_2)
            if (vehicle_data.lastpoint?.tracker?.config?.dout_1.enable === true) {
                command_source = vehicle_data.lastpoint.tracker.config.dout_1
            } else if (vehicle_data.lastpoint?.tracker?.config?.dout_2.enable === true) {
                command_source = vehicle_data.lastpoint.tracker.config.dout_2
            }

            if (command_source) {
                let lockStatus = !!(command_source.lockStatus || 1)

                new_lock_panel.value.visible = true
                // If command_source.lockStatus is 1 and command_source.value == true, then the lock is active
                // If command_source.lockStatus is 0 and command_source.value == false, then the lock is active

                // If command_source.lockStatus is 1 and command_source.value == false, then the lock is inactive
                // If command_source.lockStatus is 0 and command_source.value == true, then the lock is inactive
                new_lock_panel.value.lock_active = command_source.value === lockStatus

                new_lock_panel.value.panel_data = command_source
            }
        },
        { immediate: true }
    )

    return {
        commands,
        lock_command,
        new_lock_panel
    }
}
